<template>
  <div class="case-detail-gene-quality-data-page col-block flex-start" :class="{ 'width-full': !isFamily }">
    <div class="data-content-block col-block">
      <div class="data-row row-block stretch">
        <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position]" :style="(option.width && isFamily) ? { width: option.width } : { flex: 1 }">
          <div :style="{ flex: 1 }"></div>
          <div class="data-content" v-html="option.title"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
      <div v-for="(qualityData, qdindex) in qualityDatas" :key="qdindex" class="data-row row-block stretch">
        <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position]" :style="(option.width && isFamily) ? { width: option.width } : { flex: 1, width: 0 }">
          <div v-if="isFamily" :style="{ flex: 1 }"></div>
          <div v-if="option.value === 'genotype'  && ![null, undefined].includes(qualityData.GT)" class="data-content quality-col genotype-container col-block" :class="{ alert: false }">
            <div class="quality-value-block row-block">
              <div class="quality-value">{{ qualityData.GT_raw || qualityData.GT || 'N/A' }}</div>
            </div>
          </div>
          <div v-else-if="option.value === 'readDepth' && ![null, undefined].includes(qualityData.DP)" class="data-content quality-col readDepth-container col-block" :class="{ alert: option.info && (qualityData.DP || 0) < 10 }">
            <div class="quality-value-block row-block">
              <div class="quality-value">{{ qualityData.DP || 0 }}</div>
            </div>
            <template v-if="option.info">
              <div :style="{ height: '0px' }"></div>
              <div class="pass-info-block row-block">
                <img :src="require('../../assets/images/quality-' + ((qualityData.DP || 0) < 10 ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                <div :style="{ width: '5px' }"></div>
                <div class="pass-info" v-html="(qualityData.DP || 0) < 10 ? $t('DIALOG.caseDetailGeneQuality.pass.readDepth.___noPass') : $t('DIALOG.caseDetailGeneQuality.pass.readDepth.___pass')"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </div>
          <div v-else-if="option.value === 'alleleFractions' && ![null, undefined].includes(qualityData.GT_AF)" class="data-content quality-col alleleFractions-container col-block" :class="{ alert: option.info && ((qualityData.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(qualityData.GT)) || ((qualityData.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(qualityData.GT)) || ((qualityData.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(qualityData.GT)) }">
            <div class="quality-value-block row-block">
              <div class="quality-value">{{  qualityData.GT_AF ? qualityData.GT_AF.toFixed(3).replace(/0+$/, '').replace(/\.$/, '') : 0 }}</div>
              <div :style="{ width: '3px' }"></div>
              <div class="quality-desc">{{ '(REF:' + (qualityData.RD || 0) + ' | ALT:' + (qualityData.AD || 0) + ')' }}</div>
            </div>
            <template v-if="option.info">
              <div :style="{ height: '0px' }"></div>
              <div class="pass-info-block row-block">
                <img :src="require('../../assets/images/quality-' + (((qualityData.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(qualityData.GT)) || ((qualityData.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(qualityData.GT)) || ((qualityData.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(qualityData.GT)) ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                <div :style="{ width: '5px' }"></div>
                <div class="pass-info" v-html="((qualityData.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(qualityData.GT)) || ((qualityData.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(qualityData.GT)) || ((qualityData.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(qualityData.GT)) ? $t('DIALOG.caseDetailGeneQuality.pass.alleleFractions.___noPass') : $t('DIALOG.caseDetailGeneQuality.pass.alleleFractions.___pass')"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </div>
          <div v-else-if="option.value === 'genotypeQuality' && ![null, undefined].includes(qualityData.GQ)" class="data-content quality-col genotypeQuality-container col-block" :class="{ alert: option.info && (qualityData.GQ || 0) < 20 }">
            <div class="quality-value-block row-block">
              <div class="quality-value">{{ qualityData.GQ || 0 }}</div>
            </div>
            <template v-if="option.info">
              <div :style="{ height: '0px' }"></div>
              <div class="pass-info-block row-block">
                <img :src="require('../../assets/images/quality-' + ((qualityData.GQ || 0) < 20 ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                <div :style="{ width: '5px' }"></div>
                <div class="pass-info" v-html="(qualityData.GQ || 0) < 20 ? $t('DIALOG.caseDetailGeneQuality.pass.genotypeQuality.___noPass') : $t('DIALOG.caseDetailGeneQuality.pass.genotypeQuality.___pass')"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </div>
          <div v-else-if="option.value === 'geneCoverage'" class="data-content quality-col geneCoverage-container col-block" :class="{ alert: false }">
            <template v-if="Object.keys(getCovGene(qualityData)).length">
              <div class="quality-value-block row-block" v-for="(option, index) in option.options || []" :key="index">
                <div class="quality-value">{{ option.title + ': ' + fixNumber(getCovGene(qualityData)[option.value] * 100, 0.01) + '%' }}</div>
              </div>
            </template>
            <template v-else>
              <div class="quality-value-block row-block">
                <div class="quality-value">{{ '- -' }}</div>
              </div>
              <template v-if="!isFamily">
                <div :style="{ height: '0px' }"></div>
                <div class="pass-info-block row-block">
                  <img :src="require('../../assets/images/quality-pass-info-icon.svg')" alt="" :style="{ width: '16px', opacity: 0 }">
                </div>
              </template>
            </template>
          </div>
          <div v-else class="data-content" :class="[option.break ? 'break-line' : 'ellipsis']" :title="qualityData[option.value]" :style="option.color ? { color: option.color(qualityData[option.value], qualityData) } : {}" v-html="(option.display || (x => x))(qualityData[option.value], qualityData) || option.empty || '- -'"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultEmptyDisplay } from '../../constants/global/data'
import { fixNumber } from '../../constants/global/util'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    },
    isFamily: {
      type: Boolean,
      required: true
    },
    gene: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    coverages: {
      type: Object,
      required: true
    },
    sampleAllelegts: {
      type: Object,
      required: true
    }
  },
  computed: {
    qualityDatas () {
      let sampleAllelegt = this.sampleAllelegts[[this.variant.CHROM, this.variant.POS, this.variant.REF, this.variant.ALT].join(':')] || []
      sampleAllelegt = sampleAllelegt.reduce((result, data) => (data.sample ? { ...result, [data.sample]: { 'GT': data.gt, 'RefAlt': data.refalt } } : result), {})
      return this.isFamily ? (this.variant.fam_info || []).map(data => ({ ...data, ...(sampleAllelegt[data.sample_id || data.sample_number] || {}) })) : [this.variant]
    },
    // static
    tableOption () {
      const familyOptions = this.isFamily ? [
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.family.title.___case_id'),
          value: 'case_id',
          color: (_, data) => data.phenotype === 1 ? '#333333' : '#FA3D3D',
          width: null,
          position: 'center',
          break: true,
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.family.title.___relation'),
          value: 'relation',
          color: () => '#003679',
          width: '110px',
          position: 'center',
          break: true,
          display: value => value ? value.replace(/ /g, '<br>') : null,
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.family.title.___ra'),
          value: 'RefAlt',
          color: null,
          width: '90px',
          position: 'center',
          break: true,
          empty: this.$t(defaultEmptyDisplay.empty)
        }
      ] : []
      const singleOptions = (this.gene.SYMBOL || '').startsWith('MT-') ? [
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.title.___readDepth'),
          value: 'readDepth',
          color: null,
          width: '195px',
          info: false,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.title.___alleleFractions'),
          value: 'alleleFractions',
          color: null,
          width: '195px',
          info: false,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.title.___geneCoverage'),
          value: 'geneCoverage',
          color: null,
          width: '170px',
          options: [
            { title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.option.geneCoverage.___x2000Cov'), value: 'x2000_cov' },
            { title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.option.geneCoverage.___x3000Cov'), value: 'x3000_cov' }
          ],
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        }
      ] : [
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___genotype'),
          value: 'genotype',
          color: null,
          width: '90px',
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___readDepth'),
          value: 'readDepth',
          color: null,
          width: '195px',
          info: true,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___alleleFractions'),
          value: 'alleleFractions',
          color: null,
          width: '195px',
          info: true,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___genotypeQuality'),
          value: 'genotypeQuality',
          color: null,
          width: '175px',
          info: true,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___geneCoverage'),
          value: 'geneCoverage',
          color: null,
          width: '170px',
          options: [
            { title: this.$t('DIALOG.caseDetailGeneQuality.table.default.option.geneCoverage.___x10Cov'), value: 'x10_cov' },
            { title: this.$t('DIALOG.caseDetailGeneQuality.table.default.option.geneCoverage.___x20Cov'), value: 'x20_cov' }
          ],
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        }
      ]
      return [
        ...familyOptions,
        ...singleOptions
      ]
    },
    // global
    fixNumber () { return fixNumber }
  },
  methods: {
    getCovGene (variant) {
      let codingExon = (['Proband', undefined].includes(variant.relation) ? this.coverages['coding_exon'] : (this.coverages['fam_codin_exon'] || {})[variant.case_id]) || {}
      let allExon = (['Proband', undefined].includes(variant.relation) ? this.coverages['all_exon'] : (this.coverages['fam_all_exon'] || {})[variant.case_id]) || {}
      let result = ((codingExon[(this.gene.SYMBOL || '')] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || ((allExon[(this.gene.SYMBOL || '')] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || {}
      return result || {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/geneQualityData.vue